// extracted by mini-css-extract-plugin
export var dropdownIcon = "_so-6";
export var imgContainer = "_so-3";
export var menuIcon = "_so-5";
export var pillWrapper = "_so-2";
export var pillsContainer = "_so-1";
export var subscriptionCard = "_so-0";
export var subscriptionLogo = "_so-4";